export default __webpack_public_path__ + "static/media/coindrop_old.08d5a709.mp3";